/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * Null when Factory Models mode is deactivated or when the Factory
 * Models cache hasn't been initialized yet.
 * @export
 * @interface GuiMarketSettingsFactoryModelsSettings
 */
export interface GuiMarketSettingsFactoryModelsSettings {
  /**
   *
   * @type {number}
   * @memberof GuiMarketSettingsFactoryModelsSettings
   */
  etelViewId: number
  /**
   * Null if there's no matching Factory Model cache entry. This can
   * happen for markets that doesn't have Factory Models and for markets
   * that very recently activated Factory Models before the cache has
   * had time to initialize in SC Admin.
   * @type {string}
   * @memberof GuiMarketSettingsFactoryModelsSettings
   */
  partPeriod: string
}

/**
 * Check if a given object implements the GuiMarketSettingsFactoryModelsSettings interface.
 */
export function instanceOfGuiMarketSettingsFactoryModelsSettings(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'etelViewId' in value
  isInstance = isInstance && 'partPeriod' in value

  return isInstance
}

export function GuiMarketSettingsFactoryModelsSettingsFromJSON(
  json: any,
): GuiMarketSettingsFactoryModelsSettings {
  return GuiMarketSettingsFactoryModelsSettingsFromJSONTyped(json, false)
}

export function GuiMarketSettingsFactoryModelsSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuiMarketSettingsFactoryModelsSettings {
  if (json === undefined || json === null) {
    return json
  }
  return {
    etelViewId: json['etel_view_id'],
    partPeriod: json['part_period'],
  }
}

export function GuiMarketSettingsFactoryModelsSettingsToJSON(
  value?: GuiMarketSettingsFactoryModelsSettings | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    etel_view_id: value.etelViewId,
    part_period: value.partPeriod,
  }
}
